import { Handle, Position } from '@xyflow/react'
import { selectedBorder, activeBorder } from './selectedBorder.js'

export function StateMachineNode({ data, selected }) {
  // _debugActiveState is injected by BlueprintEditor from debugState (polled 10fps)
  const currentStateId = data._debugActiveState ?? null
  const stateNodes     = (data.innerNodes ?? []).filter(n => n.type === 'state')
  const currentState   = stateNodes.find(n => n.id === currentStateId)
  const stateCount     = stateNodes.length
  const isRunning      = currentStateId !== null

  return (
    <div
      onDoubleClick={e => { e.stopPropagation(); data.onDrillIn?.() }}
      style={{
        background: selected ? '#252b3d' : '#1a2030',
        border: `2px solid ${selected ? selectedBorder('#3a4a80') : isRunning ? activeBorder('#3a4a80') : '#3a4a80'}`,
        borderRadius: 8,
        padding: '10px 16px',
        minWidth: 190,
        color: '#ddd',
        fontFamily: 'var(--m-font)',
        fontSize: 12,
        cursor: 'default',
        userSelect: 'none',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <span style={{ fontSize: 13 }}>⚙</span>
        <span style={{ color: '#7090e0', fontWeight: 'bold', fontSize: 10, letterSpacing: 1 }}>
          STATE MACHINE
        </span>
        {isRunning && <span style={{ color: '#60c0ff', fontSize: 9, marginLeft: 'auto' }}>▶ RUNNING</span>}
      </div>

      {/* Name */}
      <div style={{ color: '#c8d8ff', fontSize: 13, fontWeight: 'bold', marginBottom: 6 }}>
        {data.name ?? 'State Machine'}
      </div>

      {/* Active state pill */}
      {currentState ? (
        <div style={{
          background: 'rgba(80,160,255,0.12)',
          border: '1px solid #3060a0',
          borderRadius: 4,
          padding: '3px 7px',
          fontSize: 10,
          color: '#80c0ff',
          marginBottom: 4,
        }}>
          ▶ {currentState.data?.name ?? '?'}
        </div>
      ) : (
        <div style={{ color: '#354050', fontSize: 10, marginBottom: 4 }}>
          {stateCount === 0 ? 'no states' : `${stateCount} state${stateCount !== 1 ? 's' : ''} · idle`}
        </div>
      )}

      {/* Double-click hint */}
      <div style={{ color: '#2a3040', fontSize: 9, fontStyle: 'italic' }}>
        double-click to open
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="anim"
        style={{ background: isRunning ? '#60c0ff' : '#6090e0', width: 10, height: 10 }}
      />
    </div>
  )
}
